import { z } from 'zod';

export type AssetType = z.infer<typeof AssetType>;

export const AssetType = z.enum(['cart', 'chargingOption', 'chargingController']);
